"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        function handleListAndTableSpecificDescriptors(rootControlParams, controlParams, descriptor, parentDataSource, parentDescriptor) {
            var dataSourceName = $dyn.serverForm.getCollectionName(descriptor.DataSourceName);
            var previousDataSourceName;
            var useReactGrid = parentDataSource && parentDataSource.getValue("UseReactGrid");
            var observableProp;
            // TODO: Missing a server descriptor concept to represent data source and selected index code done here
            if (!controlParams.DataSource) {
                observableProp = controlParams.DataSource = useReactGrid ? $dyn.observableArray() : $dyn.observable();
                if (dataSourceName) {
                    var boundDataSource = parentDataSource.getRelatedCollection(dataSourceName);
                    controlParams.DataSource.__dataSourceName = dataSourceName;
                    controlParams.DataSource.__boundDataSource = boundDataSource;
                    $dyn.oneWayBinding(boundDataSource.items, observableProp);
                    if (useReactGrid) {
                        boundDataSource.itemsChanged().subscribe(function () {
                            observableProp.valueChanged.raise();
                        });
                    }
                }
            }
            else if (dataSourceName && dataSourceName !== controlParams.DataSource.__dataSourceName) {
                previousDataSourceName = controlParams.DataSource.__dataSourceName;
                observableProp = controlParams.DataSource;
                $dyn.disposeOneWayBinding(observableProp);
                var boundDataSource = parentDataSource.getRelatedCollection(dataSourceName);
                controlParams.DataSource.__dataSourceName = dataSourceName;
                controlParams.DataSource.__boundDataSource = boundDataSource;
                $dyn.oneWayBinding(boundDataSource.items, observableProp);
            }
            var bindModelProperty = function (sourcePropertyName, targetPropertyName, defaultValue) {
                var modelObservableProp;
                if (!targetPropertyName) {
                    targetPropertyName = sourcePropertyName;
                }
                if (!controlParams[targetPropertyName]) {
                    modelObservableProp = controlParams[targetPropertyName] = $dyn.observable(defaultValue);
                    if (dataSourceName) {
                        var modelCollection = parentDataSource.getRelatedCollection(dataSourceName);
                        if (modelCollection) {
                            $dyn.oneWayBinding(modelCollection[sourcePropertyName], modelObservableProp);
                            controlParams[targetPropertyName].__dataSourceName = dataSourceName;
                            controlParams[targetPropertyName].__modelCollection = modelCollection;
                        }
                    }
                }
                else if (dataSourceName && dataSourceName !== previousDataSourceName) {
                    modelObservableProp = controlParams[targetPropertyName];
                    $dyn.disposeOneWayBinding(modelObservableProp);
                    var modelCollection = parentDataSource.getRelatedCollection(dataSourceName);
                    if (modelCollection) {
                        $dyn.oneWayBinding(modelCollection[sourcePropertyName], modelObservableProp);
                        controlParams[targetPropertyName].__dataSourceName = dataSourceName;
                        controlParams[targetPropertyName].__modelCollection = modelCollection;
                    }
                }
            };
            if (useReactGrid && controlParams._typeName === "ReactList") {
                bindModelProperty("activeRecord_mastertrackingid", "SelectedRowTrackingId", "");
                bindModelProperty("internalActiveMasterTrackingId", "InternalSelectedRowTrackingId", "");
                bindModelProperty("activeDataRowTrackingId", "ActiveRowTrackingId");
                bindModelProperty("DataAbove");
                bindModelProperty("DataBelow");
                bindModelProperty("CacheSize");
            }
            else {
                bindModelProperty("selectedIndex", "SelectedIndex", -1);
                bindModelProperty("CacheSize");
                bindModelProperty("FetchedDataStartPosition");
                bindModelProperty("DataAbove");
                bindModelProperty("DataBelow");
                bindModelProperty("markedIndexes", "MarkedIndexes", []);
            }
        }
        // Control adapters dictionary that defines a control specific server form descriptor handling behavior.
        serverForm.controlAdapters = {};
        serverForm.controlAdapters.Table = handleListAndTableSpecificDescriptors;
        serverForm.controlAdapters.List = handleListAndTableSpecificDescriptors;
        serverForm.controlAdapters.ReactList = handleListAndTableSpecificDescriptors;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ControlAdapters.js.map
